import objectFitImages from 'object-fit-images'

export default {
  data() {
    return {
    }
  },
  computed: {
  },
  mounted() {
    this.$nextTick(() => {
      let images = document.querySelectorAll('.u-cover')
      objectFitImages(images)
    })
  },
  beforeDestroy() {
  },
  methods: {
  }
}


// WEBPACK FOOTER //
// ./src/mixins/object-fit-cover.js